<template>
  <div>
    <toggle-button
      v-if="+(activeUserId ?? 0) == 101"
      :value="toggleValue"
      :height="25"
      :width="60"
      checkedText="On"
      uncheckedText="Off"
      checkedBg=" #0054a6"
      uncheckedBg="lightgrey"
      @click="onChange"
    />
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import VueToggles from "vue-toggles";

export default defineComponent({
  name: "Toggle",
  components: { "toggle-button": VueToggles },
  props: {
    toggleValue: null as any
  },
  emits: ["onToggleChange"],
  data() {
    return {
      value: this.toggleValue,
      activeUserId: sessionStorage.getItem("activeUserId")
    };
  },
  methods: {
    onChange() {
      this.value = !this.value;
      this.$emit("onToggleChange", this.value);
    }
  }
});
</script>
<style scoped>
.vue-js-switch .v-switch-input {
  position: relative !important;
  opacity: 0 !important;
  width: 40px !important;
  height: 40px !important;
  top: 12px !important;
  left: 7px !important;
  z-index: 1000 !important;
}
.vue-js-switch .v-switch-core {
  display: block !important;
  position: relative !important;
  box-sizing: border-box !important;
  outline: 0 !important;
  margin: 0 !important;
  transition:
    border-color 0.3s,
    background-color 0.3s !important;
  top: -19px !important;
  left: 5px !important;
  user-select: none !important;
}
.vue-js-switch .v-switch-label {
  position: absolute !important;
  top: 9.5px !important;
  left: 30px !important;
  font-weight: 600 !important;
  color: #0054a6 !important;
  z-index: 1 !important;
}
</style>
